import { Col, Container, Row } from 'react-bootstrap'
import partner_bg from './../assets/skyscraper-building.png'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { useEffect, useRef, useState } from 'react'
import icon1 from './../assets/mynaui_globe-solid.png'
import icon2 from './../assets/material-symbols_security.png'
import icon3 from './../assets/healthicons_money-bag.png'
import icon4 from './../assets/mdi_tools.png'
import icon5 from './../assets/tabler_gift-filled.png'
import PartnerForm from '../components/PartnerForm'
import bg_top from './../assets/150896785_10515253_2.png'
import different_1 from './../assets/Unlimited_Users.png'
import different_2 from './../assets/Group_1171275495.png'
import different_3 from './../assets/All_in_One.png'
import different_4 from './../assets/Group_11712754956.png'
import risk_1 from './../assets/streamline_bug-antivirus-shield-remix.png'
import risk_2 from './../assets/material-symbols_security.png'
import risk_3 from './../assets/material-symbols_lock.png'
import risk_4 from './../assets/mdi_key.png'
import risk_5 from './../assets/mingcute_loading-3-fill.png'
import risk_6 from './../assets/Frame_1171277331.png'

function BecomePartner() {
  const cardRef = useRef(null)
  const [cardHeight, setCardHeight] = useState(0)

  useEffect(() => {
    if (cardRef.current) {
      setCardHeight(cardRef.current.offsetHeight);
    }
  }, [])

  return (
    <div className='wrap-hidden'>
      <div className='pb-5 pt-5'
        style={{
          backgroundImage: `url(${partner_bg})`,
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom center",
          backgroundSize: "cover",
        }}
      >
        <Container className='pt-5 pb-5'>
          <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
            <div className='mt-5 header text-center'>Why Partner with <span className="text-brand-secondary">Siberwander</span></div>
            <p className='mt-4 text-center'>Join a future facing cybersecurity ecosystem designed for scalable growth, predictable revenue, and long term relevance. From world class products to hands-on enablement, we empower our partners with the tools, insights, and support needed to win in a cloud first, security driven world.</p>
            <br/>
            <p className='text-center'>This isn’t just a partnership. It’s a platform for shared success and sustainable momentum.</p>
          </AnimationOnScroll>
          
        </Container>
        <Container ref={cardRef} style={{ marginBottom: -1 * (cardHeight/1.5) }}>
          <Row className='category'>
            <Col xs={12} md className="mb-3">
              <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                  <img src={icon1} style={{width:"50px", height: "50px"}} alt=""/>
                  <div className='text-center mt-1'><strong>High-Growth Market</strong></div>
                  <p className='text-center mt-2'>Cloud and cybersecurity demand in Indonesia is booming. Now’s the time to lead.</p>
                </div>
              </AnimationOnScroll>
            </Col>
            <Col xs={12} md className="mb-3">
              <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={50} offset={100} style={{height:"100%"}}>
                <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                  <img src={icon2} style={{width:"50px", height: "50px"}} alt=""/>
                  <div className='text-center mt-1'><strong>Top-Tier Solutions</strong></div>
                  <p className='text-center mt-2'>Offer premium protection with Orca Security trusted by global enterprises.</p>
                </div>
              </AnimationOnScroll>
            </Col>
            <Col xs={12} md className="mb-3">
              <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={100} offset={100} style={{height:"100%"}}>
                <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                  <img src={icon3} style={{width:"50px", height: "50px"}} alt=""/>
                  <div className='text-center mt-1'><strong>Recurring Revenue</strong></div>
                  <p className='text-center mt-2'>Earn consistent income from subscriptions and renewals.</p>
                </div>
              </AnimationOnScroll>
            </Col>
            <Col xs={12} md className="mb-3">
              <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={150} offset={100} style={{height:"100%"}}>
                <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                  <img src={icon4} style={{width:"50px", height: "50px"}} alt=""/>
                  <div className='text-center mt-1'><strong>Exclusive Partner Tools</strong></div>
                  <p className='text-center mt-2'>Get sales kits, product training, marketing support, and expert guidance.</p>
                </div>
              </AnimationOnScroll>
            </Col>
            <Col xs={12} md className="mb-3">
              <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={200} offset={100} style={{height:"100%"}}>
                <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                  <img src={icon5} style={{width:"50px", height: "50px"}} alt=""/>
                  <div className='text-center mt-1'><strong>Rewarding Bonus Program</strong></div>
                  <p className='text-center mt-2'>Earn extra for new deals and performance milestones.</p>
                </div>
              </AnimationOnScroll>
            </Col>
          </Row>
        </Container>
      </div>
      <div className='partner-card-footer' style={{ height: cardHeight/1.8 }}/>

      <Container className='pt-5 pb-5'>
        <div className='card-shadow'>
          <Container className='pt-5 pb-5'>
            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
              <div className='header text-center'>What Makes Us <span className="text-brand-secondary">Different</span></div>
              <p className='mt-4 text-justify text-center'><strong>Modern Cloud Security, Engineered for Velocity and Clarity.</strong></p>
            </AnimationOnScroll>
          </Container>
          <div className='make-us ps-5 pe-5 pb-5'>
            <Row className='mt-4'>
              <Col md={6} xs={12} className='mb-5'>
                <div className='d-flex flex-row gap-3'>
                  <img src={different_1} style={{width:"50px", height: "50px"}} alt=""/>
                  <div className='flex-fill'>
                    <strong>Instant Agentless Deployment</strong>
                    <p className='mt-3'>No installs. No downtime. No excuses. Spin up full cloud coverage in minutes — with zero software agents and zero infrastructure friction.</p>
                  </div>
                </div>
              </Col>

              <Col md={6} xs={12} className='mb-5'>
                <div className='d-flex flex-row gap-3'>
                  <img src={different_2} style={{width:"50px", height: "50px"}} alt=""/>
                  <div className='flex-fill'>
                    <strong>Complete Cloud Visibility</strong>
                    <p className='mt-3'>100% Asset awareness. Zero blind spots. See everything across your cloud, VMs, containers and serverless functions with a single, unified view. Gain real-time, contextual visibility into every workload, every layer, every risk without deploying a single agent.</p>
                  </div>
                </div>
              </Col>

              <Col md={6} xs={12} className='mb-5'>
                <div className='d-flex flex-row gap-3'>
                  <img src={different_3} style={{width:"50px", height: "50px"}} alt=""/>
                  <div className='flex-fill'>
                    <strong>All-in-One Security, Built to Scale</strong>
                    <p className='mt-3'>One platform. Every layer protected. From posture management to API shielding, we combine deep detection, compliance assurance, and intelligent risk prioritization in a single cloud-native console.</p>
                    <br/>
                    <p>Includes:</p>
                    <ul>
                      <li>Cloud Security Posture Management (CSPM)</li>
                      <li>Cloud Infrastructure Entitlement Management (CIEM)</li>
                      <li>Cloud Workload Protection (CWP)</li>
                      <li>Kubernetes Security Posture Management (KSPM)</li>
                      <li>Shift Left Security</li>
                      <li>Data Security Posture Management (DSPM)</li>
                      <li>Cloud Detection & Response (CDR)</li>
                      <li>Network/API Security</li>
                      <li>Built in Compliance Best Practice & Standard Regulations</li>
                      <li>AI Security Posture Management (AI-SPM)</li>
                      <li>Cloud-to-Dev</li>
                    </ul>
                  </div>
                </div>
              </Col>

              <Col md={6} xs={12} className='mb-5'>
                <div className='d-flex flex-row gap-3'>
                  <img src={different_4} style={{width:"50px", height: "50px"}} alt=""/>
                  <div className='flex-fill'>
                    <strong>24/7 Managed Cloud Security</strong>
                    <p className='mt-3'>We never sleep, so you can. Our elite security ops team delivers always-on threat monitoring, rapid incident response, and proactive compliance support so your business keeps moving, securely.</p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>

      <Container className='pb-5'>
        <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
          <div className='header text-center mt-5'>Risk Covered by <span className="text-brand-secondary">Siberwander</span></div>
          <p className='mt-4 text-justify text-center'><strong>Stay Ahead of Threats Before They Become Breaches.</strong></p>
          <p className='text-justify text-center'>Siberwander helps you detect, prioritize, and respond to the most critical cloud risks long before they turn into costly incidents.</p>
          <p className='text-justify text-center'>From hidden misconfigurations to exposed sensitive data, we cover the full spectrum of cloud threats across infrastructure, workloads, users, APIs, and more.</p>
          <br/>
          <p className='text-justify text-center'>By combining deep visibility with smart automation, Siberwander doesn’t just show you what’s wrong we help you fix what matters most, fast.</p>
        </AnimationOnScroll>

        <div className='card-shadow mt-4 bg-main-secondary-light'>
          <div className='category ps-5 pe-5 pt-4'>
            <Row>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_1} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Malware</strong></div>
                    <p className='text-center mt-2'>Uncover malicious payloads with advanced signature intelligence and behavior-based scanning in real time.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={100} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_2} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Vulnerability Discovery</strong></div>
                    <p className='text-center mt-2'>Expose systemic weaknesses in operating systems, applications, and open-source libraries before attackers do.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={150} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_3} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Insecure Configurations</strong></div>
                    <p className='text-center mt-2'>Detect misconfigurations like open buckets and outdated cipher sets the silent killers of cloud security.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_4} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Authentication Risks</strong></div>
                    <p className='text-center mt-2'>Identify weak credentials, leaked passwords, and over-permissioned identities that could open the door to breaches.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={100} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_5} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Sensitive Data Exposure</strong></div>
                    <p className='text-center mt-2'>Safeguard critical assets like emails, user records, and customer PII with precision-layered data security.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={150} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_6} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Lateral Movement Defense</strong></div>
                    <p className='text-center mt-2'>Stop intruders from pivoting inside your cloud by detecting insecure keys, flat networks, and segmentation gaps.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
            </Row>
          </div>
          <div className='subheader text-center mt-2 mb-4'><span className="text-brand">And More</span></div>
        </div>
      </Container>

      <Container className='pt-5 pb-5'>
        <PartnerForm/>
      </Container>
    </div>
  )
}

export default BecomePartner